<template>
    <div>
        
    </div>
</template>

<style scoped>
    .searchform{
        padding:25px;
    }
</style>

<script>

/*
import axios from 'axios';
import { constants } from '@/constants';
import { useToast } from 'vue-toastification';
import common from '@/common';
import { Preferences } from '@capacitor/preferences';*/
import router from './../../../routes/index';
/*import SaveButton from '../UI/SaveButton.vue';*/

export default {
    name: 'search',
    components:{
        
    },
    data : function(){
        return {
                
            }
    },
    methods : {

        


    },
    created(){
        router.push('/search');
    },
    mounted(){

        


    }
}
</script>